/* SB Creation Diwali offer: string lights, marquee bulb borders, fireworks,
   countdown, and the "add both" button on the product page picker.
   Everything re-attaches when Dawn or sbc-gift-anim.js swaps cart HTML in. */
(() => {
const sbc = window.sbcDiwali = {};
// elements not yet set up; marks them so a second pass skips them
const fresh = (root, sel) => [...root.querySelectorAll(sel)].filter(el => !el.dataset.sbcOn && (el.dataset.sbcOn = '1'));

// countdown: [data-sbc-cd] holds the end time; the wrapping [data-sbc-timer] hides once it has passed
(() => {
  const pad = n => String(n).padStart(2, '0');
  const tick = () => document.querySelectorAll('[data-sbc-cd]').forEach(el => {
    const s = Math.floor((Date.parse(el.dataset.sbcCd) - Date.now()) / 1000);
    const box = el.closest('[data-sbc-timer]') || el;
    // only touch the DOM when something changed: the page-wide MutationObserver below sees every write
    if (!(s > 0)) { if (!box.hidden) box.hidden = true; return; }
    if (box.hidden) box.hidden = false;
    const set = (k, v) => { const n = el.querySelector(`[data-${k}]`); if (n && n.textContent !== String(v)) n.textContent = v; };
    set('d', Math.floor(s / 86400)); set('h', pad(Math.floor(s % 86400 / 3600))); set('m', pad(Math.floor(s % 3600 / 60))); set('s', pad(s % 60));
  });
  sbc.tick = tick;
  setInterval(tick, 1000);
})();

// glowing bulbs on canvas, used for the string lights and the marquee borders.
// Each bulb shimmers on its own clock (never blinks off); now and then one glints.
(() => {
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const dpr = Math.min(devicePixelRatio || 1, 2);
  function sprite(stops) {
    const r = 16 * dpr, c = document.createElement('canvas'); c.width = c.height = r * 2;
    const g = c.getContext('2d'), gr = g.createRadialGradient(r, r, 0, r, r, r);
    stops.forEach(([o, col]) => gr.addColorStop(o, col)); g.fillStyle = gr; g.fillRect(0, 0, r * 2, r * 2);
    return c;
  }
  const LOOK = {
    dark: { op: 'screen', r: 10, wire: 'rgba(255,220,160,.22)', glint: '255,248,230', sprites: [
      [.7, sprite([[0, '#fff'], [.12, 'rgba(255,246,222,.95)'], [.24, 'rgba(255,210,120,.42)'], [.55, 'rgba(255,190,90,.06)'], [1, 'rgba(255,190,90,0)']])],
      [.9, sprite([[0, '#fff'], [.12, 'rgba(255,230,150,.95)'], [.24, 'rgba(255,175,50,.42)'], [.55, 'rgba(255,160,40,.06)'], [1, 'rgba(255,160,40,0)']])],
      [1, sprite([[0, '#fff'], [.12, 'rgba(255,205,220,.95)'], [.24, 'rgba(255,95,145,.4)'], [.55, 'rgba(255,80,130,.05)'], [1, 'rgba(255,80,130,0)']])]] },
    light: { op: 'source-over', r: 10, wire: 'rgba(169,131,47,.6)', glint: '214,140,20', sprites: [
      [.85, sprite([[0, '#fffdf4'], [.1, '#fff1c2'], [.2, 'rgba(242,170,40,1)'], [.32, 'rgba(232,150,20,.35)'], [.6, 'rgba(232,150,20,.06)'], [1, 'rgba(232,150,20,0)']])],
      [1, sprite([[0, '#fff5f8'], [.1, '#ffd6e2'], [.2, 'rgba(226,60,115,1)'], [.32, 'rgba(210,40,100,.3)'], [.6, 'rgba(210,40,100,.05)'], [1, 'rgba(210,40,100,0)']])]] }
  };
  const pickSprite = look => { const r = Math.random(); return look.sprites.find(([p]) => r <= p)[1]; };
  const STRANDS = [3, 6, 4, 8, 4, 6];

  // swags across the top, a dimmer swag behind, and hanging strands
  function strings(W) {
    const bulbs = [], wires = [], sag = (y0, d, t) => y0 + 4 * d * t * (1 - t);
    [{ P: 260, d: 20, y0: 0, off: 130, sc: .6, al: .38, gap: 13 }, { P: 220, d: 12, y0: 2, off: 0, sc: 1, al: 1, gap: 10, strands: true }].forEach(L => {
      for (let x0 = -L.P + L.off, s = 0; x0 < W + L.P; x0 += L.P, s++) {
        wires.push({ x0, ...L });
        const n = Math.round(L.P / L.gap);
        for (let i = 0; i < n; i++) {
          const t = i / n, x = x0 + L.P * t, y = sag(L.y0, L.d, t);
          if (x < -20 || x > W + 20) continue;
          bulbs.push({ x, y, sc: L.sc, al: L.al });
          if (L.strands && i % 4 === 2) {
            const len = Math.ceil(STRANDS[(s + i) % 6] * (W < 750 ? .6 : 1));  // shorter on phones, less top padding needed
            wires.push({ strand: true, x, y, len: len * 8 });
            for (let k = 1; k <= len; k++) bulbs.push({ x, y: y + k * 8, sc: k === len ? 1.3 : .85, al: 1 });
          }
        }
      }
    });
    return { bulbs, wires };
  }

  // evenly spaced bulbs around a rounded rectangle, inset i from the canvas edge
  function frame(W, H, rad, i = 5, gap = 15) {
    const w = W - 2 * i, h = H - 2 * i, R = Math.min(rad, w / 2, h / 2), q = Math.PI * R / 2;
    const arc = (cx, cy, a0, t) => { const a = (a0 + t / R) ; return [cx + R * Math.cos(a), cy + R * Math.sin(a)]; };
    const segs = [
      [w - 2 * R, t => [i + R + t, i]], [q, t => arc(i + w - R, i + R, -Math.PI / 2, t)],
      [h - 2 * R, t => [i + w, i + R + t]], [q, t => arc(i + w - R, i + h - R, 0, t)],
      [w - 2 * R, t => [i + w - R - t, i + h]], [q, t => arc(i + R, i + h - R, Math.PI / 2, t)],
      [h - 2 * R, t => [i, i + h - R - t]], [q, t => arc(i + R, i + R, Math.PI, t)]];
    const L = segs.reduce((a, s) => a + s[0], 0), n = Math.round(L / gap), out = [];
    for (let k = 0; k < n; k++) {
      let d = k * L / n, j = 0;
      while (j < 7 && d > segs[j][0]) d -= segs[j++][0];
      out.push(segs[j][1](d));
    }
    return out;
  }

  function mount(cv, look, build, glintRate) {
    const ctx = cv.getContext('2d');
    let W = 0, H = 0, bulbs = [], wires = [], glints = [], raf = 0, last = 0;
    function layout() {
      W = cv.clientWidth; H = cv.clientHeight; cv.width = W * dpr; cv.height = H * dpr;
      ({ bulbs, wires } = build(W, H));
      bulbs.forEach(b => Object.assign(b, { img: pickSprite(look), p1: Math.random() * 6.3, p2: Math.random() * 6.3, w1: .6 + Math.random() * .9, w2: 1.7 + Math.random() * 1.6 }));
    }
    function draw(ts) {
      const t = ts / 1000;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, W, H);
      if (wires.length) {
        ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1; ctx.strokeStyle = look.wire; ctx.lineWidth = .8;
        ctx.beginPath();
        wires.forEach(w => {
          if (w.strand) { ctx.moveTo(w.x, w.y); ctx.lineTo(w.x, w.y + w.len); return; }
          ctx.moveTo(w.x0, w.y0); ctx.quadraticCurveTo(w.x0 + w.P / 2, w.y0 + 2 * w.d, w.x0 + w.P, w.y0);
        });
        ctx.stroke();
      }
      ctx.globalCompositeOperation = look.op;
      for (const b of bulbs) {
        const k = .84 + .09 * Math.sin(t * b.w1 + b.p1) + .07 * Math.sin(t * b.w2 + b.p2);
        const r = look.r * b.sc * (.92 + .08 * k);
        ctx.globalAlpha = b.al * k;
        ctx.drawImage(b.img, b.x - r, b.y - r, r * 2, r * 2);
      }
      if (!still && Math.random() < glintRate && glints.length < 3) {
        const b = bulbs[Math.random() * bulbs.length | 0];
        if (b && b.al === 1) glints.push({ b, t0: t, life: .9 + Math.random() * .5, rot: Math.random() * .8 });
      }
      glints = glints.filter(g => {
        const q = (t - g.t0) / g.life; if (q >= 1) return false;
        const a = Math.sin(Math.PI * q), len = (7 + 8 * a) * Math.min(1, g.b.sc + .15);
        ctx.save(); ctx.translate(g.b.x, g.b.y); ctx.rotate(g.rot + q * .4); ctx.globalAlpha = a;
        [[len, 1], [len * .55, .7]].forEach(([l, w], j) => {
          for (const ang of [0, Math.PI / 2]) {
            ctx.save(); ctx.rotate(ang + j * Math.PI / 4);
            const gr = ctx.createLinearGradient(-l, 0, l, 0);
            gr.addColorStop(0, `rgba(${look.glint},0)`); gr.addColorStop(.5, `rgba(${look.glint},1)`); gr.addColorStop(1, `rgba(${look.glint},0)`);
            ctx.strokeStyle = gr; ctx.lineWidth = w; ctx.beginPath(); ctx.moveTo(-l, 0); ctx.lineTo(l, 0); ctx.stroke(); ctx.restore();
          }
        });
        ctx.restore();
        return true;
      });
    }
    function tick(ts) { raf = requestAnimationFrame(tick); if (ts - last < 33) return; last = ts; draw(ts); }  // ~30fps is plenty
    layout(); draw(0);
    new ResizeObserver(() => { layout(); draw(performance.now()); }).observe(cv);
    if (still) return;
    new IntersectionObserver(([e]) => { cancelAnimationFrame(raf); if (e.isIntersecting) raf = requestAnimationFrame(tick); }).observe(cv);
  }

  sbc.bulbs = root => {
    fresh(root, 'canvas[data-sbc-lights]').forEach(cv => mount(cv, LOOK[cv.dataset.sbcLights], strings, .05));
    fresh(root, '.sbc-mq').forEach(el => {
      const cv = document.createElement('canvas'); cv.className = 'sbc-mq__cv'; cv.setAttribute('aria-hidden', 'true'); el.append(cv);
      mount(cv, LOOK[el.dataset.sbcTone || 'light'], (W, H) => ({ wires: [], bulbs: frame(W, H, (parseFloat(getComputedStyle(el).borderTopLeftRadius) || 0) + 5).map(([x, y]) => ({ x, y, sc: .62, al: 1 })) }), .025);
    });
  };
})();

// particle fireworks: rocket rises, bursts into trailing sparks with gravity
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) { sbc.fireworks = () => {}; return; }
  const CFG = {
    band: { pal: ['#ffe39a', '#ffd36b', '#fff3d6', '#ff9fbf', '#f6b73c'], op: 'lighter', w: 1.7, scale: 1, life: 1, rise: [140, 220], handoff: .5, zones: [[.04, .44, .1, .38]] },
    hero: { pal: ['#c9971f', '#d4af37', '#c2185b', '#e8891c'], op: 'source-over', w: 2, scale: .6, life: .7, rise: [50, 80], handoff: .7, zones: [[.03, .97, .1, .15]] },
    tile: { pal: ['#ffe39a', '#ffd36b', '#fff3d6', '#ff7fb0', '#f6b73c'], op: 'lighter', w: 1.5, scale: .5, life: .8, rise: [80, 140], handoff: .5, zones: [[.15, .85, .1, .32]] },
    night: { pal: ['#ffe39a', '#ffd36b', '#fff3d6', '#ff7fb0', '#f6b73c', '#8ff0cf'], op: 'lighter', w: 1.8, scale: .85, life: 1, rise: [120, 200], handoff: .45, zones: [[.04, .97, .08, .16]] }
  };
  const rnd = (a, b) => a + Math.random() * (b - a);
  const pick = a => a[Math.random() * a.length | 0];
  sbc.fireworks = root => fresh(root, 'canvas[data-sbc-fx]').forEach(cv => {
    const cfg = CFG[cv.dataset.sbcFx], ctx = cv.getContext('2d'), dpr = Math.min(devicePixelRatio || 1, 2);
    let W = 0, H = 0, parts = [], rockets = [], raf = 0;
    const size = () => { W = cv.clientWidth; H = cv.clientHeight; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); };
    function launch(wait = 0) {
      const z = pick(W < 600 ? [[.08, .92, .1, .16]] : cfg.zones);
      const tx = rnd(z[0], z[1]) * W;
      let ty = rnd(z[2], z[3]) * H;
      const ceil = cv.parentElement.querySelector('[data-sbc-fx-ceiling]');
      if (ceil) ty = Math.min(ty, ceil.getBoundingClientRect().top - cv.getBoundingClientRect().top - 40);
      if (ty < 24) return;
      rockets.push({ sx: tx + rnd(-30, 30), sy: Math.min(H, ty + rnd(...cfg.rise)), tx, ty, x: 0, y: 0, t: -wait, col: pick(cfg.pal) });
    }
    function burst(r) {
      const k = Math.random(), willow = k < .45, crackle = k > .8, n = willow ? 72 : 58, sp = (willow ? 2.4 : 3.3) * cfg.scale;
      for (let i = 0; i < n; i++) {
        const a = i / n * Math.PI * 2 + rnd(-.06, .06), v = sp * rnd(.55, 1);
        parts.push({ x: r.tx, y: r.ty, px: r.tx, py: r.ty, vx: Math.cos(a) * v, vy: Math.sin(a) * v, t: 0,
          max: (willow ? rnd(85, 115) : rnd(50, 72)) * cfg.life, g: (willow ? .045 : .03) * cfg.scale, col: willow ? cfg.pal[0] : r.col, crackle });
      }
    }
    function frame(ts) {
      raf = requestAnimationFrame(frame);
      // one at a time: next rocket rises once the current burst is half faded, so it opens as the old one goes
      if (!rockets.length && parts.every(p => p.t > p.max * cfg.handoff)) launch();
      ctx.globalCompositeOperation = 'destination-out';
      ctx.fillStyle = 'rgba(0,0,0,.22)'; ctx.fillRect(0, 0, W, H);
      ctx.globalCompositeOperation = cfg.op; ctx.lineCap = 'round';
      rockets = rockets.filter(r => {
        if (++r.t <= 0) return true;
        const px = r.x || r.sx, py = r.y || r.sy, e = 1 - (1 - r.t / 40) ** 3;
        r.x = r.sx + (r.tx - r.sx) * e; r.y = r.sy + (r.ty - r.sy) * e;
        ctx.globalAlpha = .8; ctx.strokeStyle = cfg.pal[0]; ctx.lineWidth = 1.4;
        ctx.beginPath(); ctx.moveTo(px, py); ctx.lineTo(r.x, r.y); ctx.stroke();
        if (r.t >= 40) { burst(r); return false; }
        return true;
      });
      parts = parts.filter(p => {
        p.px = p.x; p.py = p.y; p.vx *= .985; p.vy = p.vy * .985 + p.g; p.x += p.vx; p.y += p.vy;
        let a = 1 - ++p.t / p.max;
        if (p.crackle && a < .35) a = Math.random() < .5 ? 1 : 0;
        ctx.globalAlpha = Math.max(a, 0); ctx.strokeStyle = p.col; ctx.lineWidth = cfg.w * (.6 + a * .6);
        ctx.beginPath(); ctx.moveTo(p.px, p.py); ctx.lineTo(p.x, p.y); ctx.stroke();
        return p.t < p.max;
      });
    }
    new ResizeObserver(size).observe(cv);
    new IntersectionObserver(([e]) => {
      cancelAnimationFrame(raf);
      if (e.isIntersecting) raf = requestAnimationFrame(frame);
    }).observe(cv);
  });
})();

// one burst over the page when the third item goes in (free item unlocked); product page only
(() => {
  const box = document.querySelector('.product__info-container [data-sbc-count]');
  if (!box || typeof subscribe !== 'function' || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let count = +box.dataset.sbcCount;
  function burst() {
    const cv = document.createElement('canvas'); cv.className = 'sbc-burst'; cv.setAttribute('aria-hidden', 'true');
    document.body.append(cv);
    const ctx = cv.getContext('2d'), dpr = Math.min(devicePixelRatio || 1, 2), W = innerWidth, H = innerHeight;
    cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    const pal = ['#d4af37', '#f6b73c', '#c2185b', '#e8891c', '#f1d87a'], parts = [];
    [[.3, .28], [.7, .22]].forEach(([fx, fy], j) => {
      for (let i = 0; i < 54; i++) {
        const a = i / 54 * Math.PI * 2, v = 3.2 * (.55 + Math.random() * .45);
        parts.push({ x: fx * W, y: fy * H, vx: Math.cos(a) * v, vy: Math.sin(a) * v, t: -j * 14, max: 60 + Math.random() * 20, col: pal[(i + j) % pal.length] });
      }
    });
    (function step() {
      ctx.globalCompositeOperation = 'destination-out'; ctx.fillStyle = 'rgba(0,0,0,.25)'; ctx.fillRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'source-over'; ctx.lineCap = 'round'; ctx.lineWidth = 2.2;
      let alive = 0;
      for (const p of parts) {
        if (++p.t < 0) { alive++; continue; }
        if (p.t > p.max) continue;
        alive++;
        const px = p.x, py = p.y; p.vx *= .97; p.vy = p.vy * .97 + .045; p.x += p.vx; p.y += p.vy;
        ctx.globalAlpha = 1 - p.t / p.max; ctx.strokeStyle = p.col;
        ctx.beginPath(); ctx.moveTo(px, py); ctx.lineTo(p.x, p.y); ctx.stroke();
      }
      if (alive) requestAnimationFrame(step); else cv.remove();
    })();
  }
  subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
    try {
      const now = (await (await fetch(`${routes.cart_url}.js`)).json()).item_count;
      if (count < 3 && now >= 3) burst();
      count = now;
    } catch (e) {}
  });
})();

// "Add both" on the product page picker: adds two variants in one request and opens the drawer
document.addEventListener('click', async e => {
  const btn = e.target.closest('[data-sbc-add]');
  if (!btn) return;
  e.preventDefault();
  const drawer = document.querySelector('cart-drawer');
  const items = btn.dataset.sbcAdd.split(',').map(id => ({ id: +id, quantity: 1 }));
  btn.setAttribute('aria-busy', 'true');
  try {
    const body = { items };
    if (drawer) { body.sections = drawer.getSectionsToRender().map(s => s.id); body.sections_url = location.pathname; }
    const res = await fetch(`${routes.cart_add_url}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message);
    if (drawer) { drawer.classList.remove('is-empty'); drawer.renderContents(json); } else location.href = routes.cart_url;
    if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sbc-add-both' });
  } catch (err) {
    location.href = btn.href;  // fall back to the product page
  } finally {
    btn.removeAttribute('aria-busy');
  }
});

const sbcInit = (root = document) => { sbc.bulbs(root); sbc.fireworks(root); sbc.tick(); };
sbcInit();
// cart drawer and live strips are re-rendered as HTML; set up whatever is new
let sbcQueued = false;
new MutationObserver(() => {
  if (sbcQueued) return;
  sbcQueued = true;
  requestAnimationFrame(() => { sbcQueued = false; sbcInit(); });
}).observe(document.body, { childList: true, subtree: true });
})();
